module.exports = __webpack_public_path__ + "src/assets/img/hood_color.6f7a3290.svg";